const imgType = ['jpg', 'gif', 'png', 'jpeg', 'bmp']

let bytesToSize = bytes => {
  if (bytes === 0) return '0 B'
  if (bytes === '') return ''
  var k = 1024
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  var i = Math.floor(Math.log(bytes) / Math.log(k))
  return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i]
}

let sliceType = (val, num, flag, fileNum, shareStatus) => {
  if (shareStatus === -1) {
    return 'icon-default'
  }
  if ((num === 1 || fileNum > 1) && flag !== undefined) {
    return 'icon-shareDir'
  }
  if (num === 1 || fileNum > 1) {
    return 'icon-dir'
  }
  var point
  if (typeof val === 'string' && (point = val.indexOf('.')) !== -1) {
    var type = val.substring(point + 1).toLowerCase()
    if (imgType.indexOf(type) !== -1) {
      return 'icon-pic'
    } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
      return 'icon-video'
    } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
      return 'icon-muisc'
    } else if (type === 'txt') {
      return 'icon-txt'
    } else if (type === 'pdf') {
      return 'icon-pdf'
    } else if (type === 'doc' || type === 'docx') {
      return 'icon-word'
    } else if (type === 'ppt' || type === 'pptx') {
      return 'icon-ppt'
    } else if (type === 'xls' || type === 'xlsx') {
      return 'icon-excel'
    } else if (type === 'html' || type === 'htm') {
      return 'icon-html'
    } else if (type === 'wps' || type === 'wpt') {
      return 'icon-wps'
    } else if (type === 'zip' || type === 'rar') {
      return 'icon-package'
    } else {
      return 'icon-default'
    }
  }
}

let formaTime = (val) => {
  if (val !== '' || undefined || null) {
    return new Date(val).format('yyyy-MM-dd HH:mm')
  }
}

let prompt = (val, pid) => {

}

export default { bytesToSize, sliceType, formaTime }



// WEBPACK FOOTER //
// ./src/components/fileters.js